import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose, withHandlers, withProps } from 'recompose';
import LoginForm from '../components/login';
import { statusSelector } from '../selector';
import { onAuthentication } from '../actions';

export default compose(
  withRouter,
  connect(
    state => {
      const { auth } = statusSelector('auth')(state);
      return {
        isAuthenticating: auth === 'fetching',
        authError: auth === 'error',
        authErrorMessage: state.error.auth,
      };
    },
    dispatch => ({
      login: (history, data) =>
        dispatch(onAuthentication('login', data, history)),
    })
  ),
  withHandlers(initialProps => {
    const { history } = initialProps;
    return {
      loginUser: props => data => {
        const { login } = props;
        login(data, history);
      },
    };
  }),
  withProps(ownerProps => {
    const {
      loginUser,
      isAuthenticating,
      authError,
      authErrorMessage,
    } = ownerProps;
    return { loginUser, isAuthenticating, authError, authErrorMessage };
  })
)(LoginForm);



// WEBPACK FOOTER //
// ../shop_main/containers/login.js